import React from "react";
import { motion } from "framer-motion";

export const UTOPISTAS_ISO = "/img/utopistas-iso.webp";
export const UTOPISTAS_LOGO = "/img/utopistas-logo.webp";
export const UTOPISTAS_LOGO_H = "/img/utopistas-logo-h.webp";

// Isotipo Utopistas animado: la estrella late y el círculo de personas gira lentamente
export const UtopistasMark = ({ size = 260, className = "" }) => (
  <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }} data-testid="utopistas-mark">
    <motion.span aria-hidden="true" className="absolute inset-[12%] rounded-full" style={{ background: "radial-gradient(circle, rgba(212,168,0,0.55) 0%, rgba(212,168,0,0) 70%)" }}
      animate={{ scale: [0.9, 1.15, 0.9], opacity: [0.6, 1, 0.6] }} transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }} />
    {[0, 1, 2].map((i) => (
      <motion.span key={i} aria-hidden="true" className="absolute inset-0 rounded-full border border-cometa-marino/20"
        initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: [0.6, 1.25], opacity: [0.5, 0] }} transition={{ duration: 4, repeat: Infinity, delay: i * 1.3, ease: "easeOut" }} />
    ))}
    <motion.img src={UTOPISTAS_ISO} alt="Isotipo Utopistas" className="relative w-[78%] h-[78%] object-contain drop-shadow-xl" decoding="async"
      animate={{ rotate: 360 }} transition={{ duration: 60, repeat: Infinity, ease: "linear" }} whileHover={{ scale: 1.06 }} />
  </div>
);

export const UtopistasWordmark = ({ className = "" }) => (
  <motion.img src={UTOPISTAS_LOGO} alt="Utopistas by Dra. Cometa" className={`object-contain ${className}`} decoding="async" data-testid="utopistas-logo"
    initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, ease: "easeOut" }} />
);
